
const initialState = {
    employeeProperty:{
      employee_id: null,
       employee_token_str: null,
       employee_mobile:null,
       employee_name:null,
       employee_family: null,
       employee_image: null
    }
}

function employeeFunc(state = initialState , action) {
    switch (action.type) {

            case 'SETPROPEMPLOYEE':
            return {
              employeeProperty : action.state,
            }

            case 'CLEARPROPATEEMPLOYEE':
            return {
              employeeProperty:{
                employee_id: null,
                 employee_token_str: null,
                 employee_mobile:null,
                 employee_name:null,
                employee_family: null,
                employee_image: null
              }
                        }

        default:
            return state;
    }
}


export default employeeFunc;
